<style>
.myflex {
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.logoimg {
  max-width: 300px;
}
</style>

<template>
    <v-layout row wrap class="myflex">
        <v-flex xs12 md4>
        <img class="logoimg" src="./../assets/img/MyFireBase.svg" alt="MyfirebaseLogo">
        </v-flex>
        <v-flex xs12 md8>
          <p class="display-1 font-weight-thin">Добро пожаловать на платформу для инвестирования в реальный бизнес
          </p>
        </v-flex>
    </v-layout>
</template>
<script>
export default {
    mounted () {
        //
    },
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// Welcome.vue?f6ec074a